<template>
  <!-- Báo có dữ liệu HIS/App mới hơn lần coach lưu; coach tự chọn dùng hay không -->
  <div v-if="notice" class="source-notice">
    <i class="fas fa-info-circle source-notice__icon"></i>
    <span class="source-notice__text">{{ notice.text }}</span>
    <button v-if="canApply" type="button" class="source-notice__btn" @click="$emit('apply')">
      Dùng giá trị này
    </button>
  </div>
</template>

<script>
export default {
  name: 'SourceValueNotice',
  props: {
    notice: { type: Object, default: null },
    canApply: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.source-notice {
  margin: -0.75rem 0 1rem;
  padding: 6px 10px;
  border-radius: 6px;
  background: #FFF8DD;
  color: #7E5A00;
  font-size: 12px;
  line-height: 1.4;
}

.source-notice__icon {
  color: #FFA800;
  font-size: 12px;
  margin-right: 4px;
}

.source-notice__text {
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.source-notice__btn {
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: none;
  color: #3699FF;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.source-notice__btn:hover {
  text-decoration: underline;
}
</style>
